//Dependencies
import React from 'react';
import { Affix } from 'antd';
import { InfoFilledIcon, LayerFilledIcon } from '../../../icons/icons';
import { useDispatch } from 'react-redux';
//Actions
import { infoNotification } from '../../../store/actions/NotificationsActions';

/* SIDEMENU */
const Sidemenu01 = (props) =>
{  
  const { height, layers, visible, isMobile } = props; 
  const dispatch = useDispatch();

  if(!visible) return null;

  const clickInfo = () =>
  {
    dispatch({type: 'SET_MODAL_01', modal01 : true});
    infoNotification('info', isMobile);
  };
  
  return(
    <Affix 
      style = {{ position: "fixed", bottom: height, right: 10, zIndex : 1000}}
    >
      <div>
        <div 
          className = "flex items-center justify-center text-white p-3 text-center mb-5 md:w-16 md:h-16 w-12 h-12 shadow-lg rounded-full cursor-pointer bg-gray-800 hover:bg-sky-600"
          onClick   = {() => dispatch({type: 'SET_LAYERS', layers : !layers})}
        >
          <LayerFilledIcon style = {{ fontSize: window.innerWidth < '768' ?  '1rem':'1.5rem'}}/>
        </div>

        <div 
          className = "flex items-center justify-center text-white p-3 text-center mb-5 md:w-16 md:h-16 w-12 h-12 shadow-lg rounded-full cursor-pointer bg-gray-800 hover:bg-sky-600"
          onClick   = {() => clickInfo()}
        >
          <InfoFilledIcon style = {{ fontSize: window.innerWidth < '768' ?  '1rem':'1.5rem'}}/>
        </div>
      </div>
    </Affix>
  );
}

export default Sidemenu01;